// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.theme1 * {
  font-family: Roboto, Helvetica, Arial, sans-serif;
}
.theme1 .page-container {
  background-color: rgb(240, 242, 245);
  color: rgb(52, 71, 103);
  position: relative;
}
.theme1 .page-container .disabled {
  pointer-events: none;
}
.theme1 .page-container .rignt {
  flex-grow: 1 !important;
}
.theme1 .page-container a {
  text-decoration: none;
  color: inherit;
}
.theme1 .page-container .btn {
  background-color: rgb(26, 115, 232);
  color: #fff;
}
.theme1 .page-container button:disabled {
  opacity: 0.7;
}
.theme1 .page-container .card {
  background-color: rgb(255, 255, 255);
  background-clip: border-box;
  color: rgb(52, 71, 103);
  border: 0px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.75rem;
  box-shadow: rgba(0, 0, 0, 0.1) 0rem 0.25rem 0.375rem -0.0625rem, rgba(0, 0, 0, 0.06) 0rem 0.125rem 0.25rem -0.0625rem;
}
.theme1 .page-container .strong {
  font-weight: 500;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.theme1 .page-container .actions {
  justify-content: center;
}
.theme1 .page-container .actions > * {
  margin-right: 2rem;
}
.theme1 .page-container td {
  position: relative;
}
.theme1 .page-container .error {
  color: red;
  position: absolute;
  font-size: small;
  left: 18px;
  bottom: -10px;
}
.theme1 .page-container .error.select {
  bottom: -22px;
  left: 7px;
}
.theme1 .page-container .user-form-error {
  position: absolute;
  left: 0;
  bottom: -20px;
  color: red;
}
.theme1 .page-container .user-form-row {
  position: relative;
}
.theme1 .page-container .wrap-text {
  word-wrap: break-word;
  text-wrap: wrap;
}
.theme1 .page-container .pagination-drop-down {
  font-size: 12px !important;
  font-weight: 400 !important;
  color: rgba(0, 0, 0, 0.6) !important;
}
.theme1 .page-container .recipe-room-link-form .error, .theme1 .page-container .recipe-edit .error {
  bottom: -15px;
}
.theme1 .page-container .user-edit .error {
  bottom: -4px;
}
.theme1 .page-container .user-edit .error.select {
  bottom: -18px;
}
.theme1 .page-container .edit-icon:not(.disabled), .theme1 .page-container .copy-icon:not(.disabled), .theme1 .page-container .hash-for-push-icon:not(.disabled) {
  cursor: pointer;
}
.theme1 .page-container .edit-icon:not(.disabled):hover, .theme1 .page-container .copy-icon:not(.disabled):hover, .theme1 .page-container .hash-for-push-icon:not(.disabled):hover {
  color: rgb(26, 115, 232);
}
.theme1 .page-container .hash-for-push-icon:not(.disabled) {
  cursor: pointer;
}
.theme1 .page-container .hash-for-push-icon:not(.disabled):hover {
  color: rgb(57, 194, 57);
}
.theme1 .page-container .delete-icon:not(.disabled) {
  cursor: pointer;
}
.theme1 .page-container .delete-icon:not(.disabled):hover {
  color: rgba(255, 0, 0, 0.8);
}
.theme1 .page-container .edit-icon, .theme1 .page-container .delete-icon, .theme1 .page-container .copy-icon {
  cursor: pointer;
}
.theme1 .page-container .data-table .pagination {
  padding: 0.5rem;
}
.theme1 .page-container .data-table .pagination .right-btn, .theme1 .page-container .data-table .pagination .left-btn {
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 50%;
  padding: 0.3rem;
  color: rgb(73, 80, 87);
  height: 20px;
  width: 20px;
}
.theme1 .page-container .data-table .pagination .right-btn:hover, .theme1 .page-container .data-table .pagination .left-btn:hover {
  background-color: rgba(0, 0, 0, 0.05);
  cursor: pointer;
}
.theme1 .page-container .data-table .pagination input {
  padding: 0;
}
.theme1 .page-container .data-table .pagination input[type=number], .theme1 .page-container .data-table .pagination .select {
  height: 1.5rem;
  width: 4.5rem;
}
.theme1 .page-container .data-table .pagination input[type=number] {
  border: none;
  padding: 0 0 0 14px;
  width: calc(4.5rem - 14px);
  color: rgba(0, 0, 0, 0.87);
  font-size: 0.875rem;
  font-weight: 400;
  border-radius: 0.375rem;
  border: 1.5px solid #d3d3d3;
}
.theme1 .page-container .data-table .pagination input[type=number]:focus {
  border-color: #1976d2;
  border-width: 2px;
  outline: none;
}
.theme1 .page-container .data-table thead th:first-child {
  border-radius: 0.75rem 0 0 0;
}
.theme1 .page-container .data-table thead th:last-child {
  border-radius: 0 0.75rem 0 0;
}
.theme1 .page-container .data-table tr th, .theme1 .page-container .data-table tr td {
  padding: 12px 16px;
}
.theme1 .page-container .data-table tr th {
  background-color: rgba(0, 0, 0, 0.74);
  color: #fff;
}
.theme1 .page-container .data-table tr td {
  background-color: rgb(255, 255, 255);
  color: rgb(123, 128, 154);
}
.theme1 .page-container .data-table tr td.hover:hover {
  cursor: pointer;
}
.theme1 .page-container .data-table tr:nth-of-type(odd) td {
  background-color: rgba(0, 0, 0, 0.05);
}
.theme1 .page-container .horizontal-divider {
  flex-shrink: 0;
  border-top: 0px solid rgba(0, 0, 0, 0.08);
  border-right: 0px solid rgba(0, 0, 0, 0.08);
  border-left: 0px solid rgba(0, 0, 0, 0.08);
  height: 0.0625rem;
  margin: 1rem 0px;
  border-bottom: none;
  opacity: 0.35;
  background-color: transparent;
  background-image: linear-gradient(to right, rgba(255, 255, 255, 0), rgb(255, 255, 255), rgba(255, 255, 255, 0)) !important;
}
.theme1 .page-container .side-bar {
  background-color: rgba(0, 0, 0, 0.74);
  color: #fff;
  position: -webkit-sticky;
  position: sticky;
  top: 1rem;
  height: calc(97vh - 2rem);
  margin: 1rem;
  padding: 0px;
  border-radius: 0.75rem 0 0 0.75rem;
}
.theme1 .page-container .side-bar .menu-icon {
  color: #fff;
}
.theme1 .page-container .side-bar .logo-icon {
  width: 10rem;
}
.theme1 .page-container .side-bar .menu-item {
  padding: 0.5rem 1rem;
  margin: 0.09375rem 1rem;
  border-radius: 0.375rem;
  -webkit-user-select: none;
          user-select: none;
  white-space: nowrap;
  cursor: pointer;
  height: 3rem;
}
.theme1 .page-container .side-bar .menu-item:hover {
  background-color: rgba(255, 255, 255, 0.2);
}
.theme1 .page-container .side-bar .active .menu-item {
  background-color: #4da565;
}
@media only screen and (max-width: 900px) {
  .theme1 .page-container .side-bar .side-bar-list {
    width: 68px;
    overflow: hidden;
  }
  .theme1 .page-container .side-bar .side-bar-list:hover {
    width: auto;
  }
}
.theme1 .page-container .heading {
  color: rgb(52, 71, 103);
  font-weight: 700;
  margin: 0;
  text-transform: capitalize;
}
.theme1 .page-container .top_container {
  padding: 1rem;
  margin: 1rem;
  outline: 1rem solid rgb(240, 242, 245);
  margin-left: 0;
  position: -webkit-sticky;
  position: sticky;
  border-radius: 0.75rem;
  z-index: 1000;
  top: 1rem;
  background-color: white;
  color: rgb(123, 128, 154);
}
.theme1 .page-container .top_container .search-field {
  width: 20rem;
}
.theme1 .page-container .top_container .breadcrumb {
  color: rgb(123, 128, 154);
}
.theme1 .page-container .top_container .breadcrumb .home-icon {
  position: relative;
  top: 2px;
}
.theme1 .page-container .top_container .breadcrumb li:last-child {
  color: rgb(52, 71, 103);
}
.theme1 .page-container .top_container .menu-icon {
  -webkit-user-select: none;
          user-select: none;
  display: inline-block;
  color: rgb(123, 128, 154);
}
.theme1 .page-container .top_container .search-icon:hover, .theme1 .page-container .top_container .person-wrapper, .theme1 .page-container .top_container .badge-wrapper {
  cursor: pointer;
}
.theme1 .page-container .top_container .person-wrapper {
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
}
.theme1 .page-container .top_container .badge-wrapper {
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
}
.theme1 .page-container .master-page-container {
  display: grid;
  grid-template-columns: auto 1fr;
}
.theme1 .page-container .master-page-container .right {
  display: grid;
  grid-template-rows: auto 1fr;
}
.theme1 .page-container .master-page-container .main-content-wrapper {
  position: relative;
  box-sizing: border-box;
  padding-right: 1rem;
}
.theme1 .page-container .master-page-container .main-content-wrapper .dash-board {
  position: relative;
  margin: 10px 0px;
  overflow: scroll;
}
.theme1 .page-container .master-page-container .main-content-wrapper .dash-board .left {
  flex: 0 0 auto;
}
.theme1 .page-container .master-page-container .main-content-wrapper .dash-board .right {
  flex: 1;
}
.theme1 .page-container .master-page-container .main-content-wrapper .dash-board .info-left {
  font-weight: 500;
}
.theme1 .page-container .master-page-container .main-content-wrapper .dash-board .actions-dashboard {
  position: fixed;
  right: 3rem;
  top: 8.3rem;
  z-index: 1001;
}
.theme1 .page-container .master-page-container .main-content-wrapper .dash-board .actions-dashboard .zoom-icon, .theme1 .page-container .master-page-container .main-content-wrapper .dash-board .actions-dashboard .refresh-icon {
  color: rgb(26, 115, 232);
}
.theme1 .page-container .master-page-container .main-content-wrapper .dash-board .actions-dashboard .refresh-icon:hover {
  animation: spin 0.5s linear;
}
.theme1 .page-container .master-page-container .main-content-wrapper .dash-board .actions-dashboard:hover {
  cursor: pointer;
}
.theme1 .page-container .master-page-container .main-content-wrapper .dash-board.full {
  background-color: rgb(240, 242, 245);
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1000;
  margin: 1.5rem;
  overflow: scroll;
}
.theme1 .page-container .master-page-container .main-content-wrapper .dash-board.full .actions-dashboard {
  top: 3rem;
  right: 3rem;
}
.theme1 .page-container .master-page-container .main-content-wrapper .dash-board .btn {
  color: white;
}
.theme1 .page-container .master-page-container .main-content-wrapper .dash-board .title {
  color: rgb(52, 71, 103);
  font-weight: 700;
  margin: 0;
  text-transform: capitalize;
}
.theme1 .page-container .master-page-container .main-content-wrapper .dash-board .chart-title, .theme1 .page-container .master-page-container .main-content-wrapper .dash-board .info-title {
  text-align: center;
  color: #4da565;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  border: 1px solid #4da565;
  text-align: center;
  font-size: medium;
  padding: 0.2rem;
  border-radius: 0.2rem;
}
.theme1 .page-container .master-page-container .main-content-wrapper .dash-board .full-page-chart {
  padding: 1rem;
}
.theme1 .page-container .master-page-container .main-content-wrapper .dash-board .card {
  position: relative;
}
.theme1 .page-container .master-page-container .main-content-wrapper .dash-board .card table {
  border-collapse: collapse;
  width: 100%;
}
.theme1 .page-container .master-page-container .main-content-wrapper .dash-board .card th, .theme1 .page-container .master-page-container .main-content-wrapper .dash-board .card td {
  padding: 1rem; /* Adjust the padding for cells */
  text-align: left;
  width: 50%;
}
.theme1 .page-container .master-page-container .main-content-wrapper .dash-board .card .info td {
  width: auto;
  padding: 0.5rem;
}
.theme1 .page-container .master-page-container .main-content-wrapper .dash-board .card .chart.zoom-out:hover {
  transform: scale(1.02);
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.06);
}
.theme1 .page-container .master-page-container .main-content-wrapper .users-page > *, .theme1 .page-container .master-page-container .main-content-wrapper .rooms-page > *, .theme1 .page-container .master-page-container .main-content-wrapper .recipes-page > *, .theme1 .page-container .master-page-container .main-content-wrapper .roles-page > *, .theme1 .page-container .master-page-container .main-content-wrapper .dash-board > *, .theme1 .page-container .master-page-container .main-content-wrapper .activity-page > * {
  margin-bottom: 1rem;
}
.theme1 .page-container .master-page-container .main-content-wrapper .users-page .user, .theme1 .page-container .master-page-container .main-content-wrapper .users-page .user-edit {
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  min-width: 450px;
}
.theme1 .page-container .master-page-container .main-content-wrapper .users-page .user td, .theme1 .page-container .master-page-container .main-content-wrapper .users-page .user-edit td {
  border: 0;
  padding: 13px;
}
.theme1 .page-container .master-page-container .main-content-wrapper .users-page .user .check-box > td, .theme1 .page-container .master-page-container .main-content-wrapper .users-page .user-edit .check-box > td {
  padding: 0 13px;
}
.theme1 .page-container .master-page-container .main-content-wrapper .rooms-page .room-edit, .theme1 .page-container .master-page-container .main-content-wrapper .rooms-page .room {
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  min-width: 450px;
}
.theme1 .page-container .master-page-container .main-content-wrapper .rooms-page .room-edit table, .theme1 .page-container .master-page-container .main-content-wrapper .rooms-page .room table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 25px;
}
.theme1 .page-container .master-page-container .main-content-wrapper .rooms-page .room-edit table td, .theme1 .page-container .master-page-container .main-content-wrapper .rooms-page .room table td {
  padding: 0 10px;
}
.theme1 .page-container .master-page-container .main-content-wrapper .rooms-page .room-edit .error, .theme1 .page-container .master-page-container .main-content-wrapper .rooms-page .room .error {
  bottom: -17px;
}
.theme1 .page-container .master-page-container .main-content-wrapper .room-content, .theme1 .page-container .master-page-container .main-content-wrapper .role-content, .theme1 .page-container .master-page-container .main-content-wrapper .user-content {
  min-width: 350px;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  max-width: 79vw;
}
.theme1 .page-container .master-page-container .main-content-wrapper .room-content *, .theme1 .page-container .master-page-container .main-content-wrapper .role-content *, .theme1 .page-container .master-page-container .main-content-wrapper .user-content * {
  text-wrap: wrap;
  word-break: break-all;
}
.theme1 .page-container .master-page-container .main-content-wrapper .room-content > div:not(.btns), .theme1 .page-container .master-page-container .main-content-wrapper .role-content > div:not(.btns), .theme1 .page-container .master-page-container .main-content-wrapper .user-content > div:not(.btns) {
  display: grid;
  grid-template-columns: 110px 2rem 1fr;
  padding: 0.6rem;
}
.theme1 .page-container .master-page-container .main-content-wrapper .room-content > div:not(.btns) div:first-child, .theme1 .page-container .master-page-container .main-content-wrapper .role-content > div:not(.btns) div:first-child, .theme1 .page-container .master-page-container .main-content-wrapper .user-content > div:not(.btns) div:first-child {
  font-weight: 500;
}
.theme1 .page-container .master-page-container .main-content-wrapper .room-content .btns, .theme1 .page-container .master-page-container .main-content-wrapper .role-content .btns, .theme1 .page-container .master-page-container .main-content-wrapper .user-content .btns {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
}
.theme1 .page-container .master-page-container .main-content-wrapper .recipes-page .recipe-constraints {
  position: relative;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  overflow: unset;
  margin-top: 10px;
}
.theme1 .page-container .master-page-container .main-content-wrapper .recipes-page .recipe-constraints .title {
  position: absolute;
  margin: 0;
  top: -10px;
  left: 10px;
  background-color: white;
  padding: 0 5px;
}
.theme1 .page-container .master-page-container .main-content-wrapper .recipes-page .recipe-edit table:not(.data-table) {
  border-collapse: separate;
  border-spacing: 0 25px;
}
.theme1 .page-container .master-page-container .main-content-wrapper .recipes-page .recipe-edit table:not(.data-table) td {
  padding: 0 10px;
}
.theme1 .page-container .master-page-container .main-content-wrapper .recipes-page .recipe-edit .recipe-edit-table th {
  padding: 10px;
}
.theme1 .page-container .master-page-container .main-content-wrapper .recipes-page .recipe-edit .recipe-edit-table td {
  padding-bottom: 10px;
}
.theme1 .page-container .master-page-container .main-content-wrapper .recipes-page .recipe-edit .recipe-edit-table tr:last-child td {
  padding-bottom: 0;
}
.theme1 .page-container .master-page-container .main-content-wrapper .recipes-page .form-body > * {
  margin-bottom: 1rem;
}
.theme1 .page-container .master-page-container .main-content-wrapper .roles-page .role {
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
}
.theme1 .page-container .master-page-container .main-content-wrapper .roles-page label {
  background-color: white;
  padding-right: 5px;
}
.theme1 .page-container .master-page-container .main-content-wrapper .roles-page .drop-down {
  margin: 0;
}
.theme1 .page-container .master-page-container .main-content-wrapper .roles-page .role-edit table {
  min-width: 380px;
  margin-right: 1rem;
  border-collapse: separate;
  border-spacing: 0 25px;
}
.theme1 .page-container .master-page-container .main-content-wrapper .roles-page .role-edit .error {
  bottom: -16px;
}
.theme1 .page-container .master-page-container .main-content-wrapper .roles-page .role-creation {
  position: relative;
}
.theme1 .page-container .master-page-container .main-content-wrapper .activity-page .filter-form {
  min-width: 20rem;
  max-width: 30rem;
  display: flex;
  flex-direction: column;
  padding: 2rem;
  gap: 1rem;
}
.theme1 .page-container .master-page-container .main-content-wrapper .activity-page .filter-form .select {
  margin: 0;
}
.theme1 .page-container .master-page-container .main-content-wrapper .activity-page .filter-form > *:not(.btns) {
  display: grid;
  grid-template-columns: 100px 1fr;
  align-items: center;
}
.theme1 .page-container .master-page-container .main-content-wrapper .activity-page .filter-form .action {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0;
  margin-left: -10px;
}
.theme1 .page-container .master-page-container .main-content-wrapper .activity-page .filter-form .date-range {
  padding: 0;
  height: 40px;
}
.theme1 .page-container .master-page-container .main-content-wrapper .activity-page .filter-form .date-range input {
  padding: 8.8px 10px;
}
.theme1 .page-container .master-page-container .main-content-wrapper .activity-page .filter-form .btns {
  margin-top: 1rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.theme1 .page-container .master-page-container .main-content-wrapper .activity-page .filter-form .btns div {
  display: flex;
  flex-direction: row;
  gap: 1rem;
}

.swal2-confirm {
  background-color: rgb(26, 115, 232) !important;
}

.swal2-actions {
  gap: 1rem;
}
.swal2-actions .delete-confirm {
  background-color: rgb(221, 51, 51) !important;
}

.swal2-title {
  position: absolute;
  width: 88%;
  font-size: 27px;
  border: 0px solid rgba(0, 0, 0, 0.125);
  padding: 15px 30px;
  background-color: #f2f2f2;
  box-shadow: rgba(0, 0, 0, 0.1) 0rem 0.25rem 0.375rem -0.0625rem, rgba(0, 0, 0, 0.06) 0rem 0.125rem 0.25rem -0.0625rem;
}

.swal2-icon {
  margin-top: 75px;
}

.swal2-popup {
  overflow: hidden;
}

.swal2-html-container {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  font-size: 20px;
}
.swal2-html-container .sub-title {
  font-weight: 600;
  padding: 10px 0px;
}`, "",{"version":3,"sources":["webpack://./src/styles/masterpage.scss","webpack://./src/styles/main.scss"],"names":[],"mappings":"AAII;EACI,iDAAA;ACHR;ADKI;EACI,oCAAA;EACA,uBAAA;EACA,kBAAA;ACHR;ADIQ;EACI,oBAAA;ACFZ;ADIQ;EACI,uBAAA;ACFZ;ADIQ;EACI,qBAAA;EACA,cAAA;ACFZ;ADKQ;EACI,mCAAA;EACA,WAAA;ACHZ;ADMQ;EACI,YAAA;ACJZ;ADOQ;EACI,oCAAA;EACA,2BAAA;EACA,uBAAA;EACA,sCAAA;EACA,sBAAA;EACA,qHAAA;ACLZ;ADQQ;EACI,gBAAA;ACNZ;ADSQ;EACI;IACG,uBAAA;ECPb;EDSS;IACI,yBAAA;ECPb;AACF;ADWQ;EACI,uBAAA;ACTZ;ADUY;EACI,kBAAA;ACRhB;ADYQ;EACI,kBAAA;ACVZ;ADaQ;EACI,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,aAAA;ACXZ;ADYY;EACI,aAAA;EACA,SAAA;ACVhB;ADcQ;EACI,kBAAA;EACA,OAAA;EACA,aAAA;EACA,UAAA;ACZZ;ADeQ;EACI,kBAAA;ACbZ;ADgBQ;EACI,qBAAA;EACA,eAAA;ACdZ;ADiBQ;EACI,0BAAA;EACA,2BAAA;EACA,oCAAA;ACfZ;ADmBY;EACI,aAAA;ACjBhB;ADqBY;EACI,YAAA;ACnBhB;ADqBY;EACI,aAAA;ACnBhB;ADyBQ;EACI,eAAA;ACvBZ;ADwBY;EACI,wBAAA;ACtBhB;ADyBQ;EACI,eAAA;ACvBZ;ADwBY;EACI,uBAAA;ACtBhB;ADyBQ;EACI,eAAA;ACvBZ;ADwBY;EACI,2BAAA;ACtBhB;AD0BQ;EACI,eAAA;ACxBZ;AD4BY;EACI,eAAA;AC1BhB;AD+BgB;EACI,sCAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;AC7BpB;AD8BoB;EACI,qCAAA;EACA,eAAA;AC5BxB;AD+BgB;EACI,UAAA;AC7BpB;AD+BgB;EACI,cAAA;EACA,aAAA;AC7BpB;AD+BgB;EACI,YAAA;EACA,mBAAA;EACA,0BAAA;EACA,0BAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,2BAAA;AC7BpB;AD8BoB;EACI,qBAAA;EACA,iBAAA;EACA,aAAA;AC5BxB;ADiCgB;EACI,4BAAA;AC/BpB;ADiCgB;EACI,4BAAA;AC/BpB;ADmCgB;EACI,kBAAA;ACjCpB;ADmCgB;EACI,qCAAA;EACA,WAAA;ACjCpB;ADmCgB;EACI,oCAAA;EACA,yBAAA;ACjCpB;ADkCoB;EACI,eAAA;AChCxB;ADmCgB;EACI,qCAAA;ACjCpB;ADsCQ;EACI,cAAA;EACA,yCAAA;EACA,2CAAA;EACA,0CAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,6BAAA;EACA,0HAAA;ACpCZ;ADsCQ;EACI,qCAAA;EACA,WAAA;EACA,wBAAA;EAAA,gBAAA;EACA,SAAA;EAQA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kCAAA;AC3CZ;ADiCY;EACI,WAAA;AC/BhB;ADiCY;EACI,YAAA;AC/BhB;ADuCY;EACI,oBAAA;EACA,uBAAA;EACA,uBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;ACrChB;ADsCgB;EACI,0CAAA;ACpCpB;ADuCY;EACI,yBAAA;ACrChB;ADwCY;EACI;IACI,WAAA;IACA,gBAAA;ECtClB;EDuCkB;IACI,WAAA;ECrCtB;AACF;AD2CQ;EACI,uBAAA;EACA,gBAAA;EACA,SAAA;EACA,0BAAA;ACzCZ;AD4CQ;EACI,aAAA;EACA,YAAA;EACA,sCAAA;EACA,cAAA;EACA,wBAAA;EAAA,gBAAA;EACA,sBAAA;EACA,aAAA;EACA,SAAA;EACA,uBAAA;EACA,yBAAA;AC1CZ;AD2CY;EACI,YAAA;ACzChB;AD2CY;EACI,yBAAA;ACzChB;AD0CgB;EACI,kBAAA;EACA,QAAA;ACxCpB;AD0CgB;EACI,uBAAA;ACxCpB;AD2CY;EACI,yBAAA;UAAA,iBAAA;EACA,qBAAA;EACA,yBAAA;ACzChB;AD2CY;EACI,eAAA;ACzChB;AD2CY;EACI,0BAAA;EAAA,uBAAA;EAAA,kBAAA;ACzChB;AD2CY;EACI,0BAAA;EAAA,uBAAA;EAAA,kBAAA;ACzChB;AD6CQ;EACI,aAAA;EACA,+BAAA;AC3CZ;AD4CY;EACI,aAAA;EACA,4BAAA;AC1ChB;AD4CY;EACI,kBAAA;EACA,sBAAA;EACA,mBAAA;AC1ChB;AD2CgB;EACI,kBAAA;EACA,gBAAA;EACA,gBAAA;ACzCpB;AD0CoB;EACI,cAAA;ACxCxB;AD0CoB;EACI,OAAA;ACxCxB;AD0CoB;EACI,gBAAA;ACxCxB;AD0CoB;EAOI,eAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;AC9CxB;ADqCwB;EACI,wBAAA;ACnC5B;ADqCwB;EACI,2BAAA;ACnC5B;ADyCwB;EACI,eAAA;ACvC5B;AD0CoB;EACI,oCAAA;EACA,sBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;ACxCxB;ADyCwB;EACI,SAAA;EACA,WAAA;ACvC5B;AD0CoB;EACI,YAAA;ACxCxB;AD2CoB;EACI,uBAAA;EACA,gBAAA;EACA,SAAA;EACA,0BAAA;ACzCxB;AD4CoB;EACI,kBAAA;EACA,cAAA;EACA,0BAAA;EAAA,uBAAA;EAAA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;AC1CxB;AD4CoB;EACI,aAAA;AC1CxB;AD4CoB;EACI,kBAAA;AC1CxB;AD2CwB;EACI,yBAAA;EACA,WAAA;ACzC5B;AD4CwB;EACI,aAAA,EAAA,iCAAA;EACA,gBAAA;EACA,UAAA;AC1C5B;AD6C4B;EACI,WAAA;EACA,eAAA;AC3ChC;AD+C4B;EACI,sBAAA;EACA,eAAA;EACA,qCAAA;AC7ChC;ADmDoB;EACI,mBAAA;ACjDxB;ADqDoB;EAEI,0BAAA;EAAA,uBAAA;EAAA,kBAAA;EACA,gBAAA;ACpDxB;ADqDwB;EACI,SAAA;EACA,aAAA;ACnD5B;ADqDwB;EACI,eAAA;ACnD5B;ADwDoB;EACI,0BAAA;EAAA,uBAAA;EAAA,kBAAA;EACA,gBAAA;ACtDxB;ADyDwB;EACI,WAAA;EACA,yBAAA;EACA,sBAAA;ACvD5B;ADwD4B;EACI,eAAA;ACtDhC;ADyDwB;EACI,aAAA;ACvD5B;AD4DgB;EACI,gBAAA;EACA,0BAAA;EAAA,uBAAA;EAAA,kBAAA;EACA,eAAA;AC1DpB;AD2DoB;EACI,eAAA;EACA,qBAAA;ACzDxB;AD2DoB;EAII,aAAA;EACA,qCAAA;EACA,eAAA;AC5DxB;ADuDwB;EACI,gBAAA;ACrD5B;AD2DoB;EACI,aAAA;EACA,uBAAA;EACA,gBAAA;ACzDxB;AD6DoB;EACI,kBAAA;EACA,0BAAA;EAAA,uBAAA;EAAA,kBAAA;EACA,eAAA;EACA,gBAAA;AC3DxB;AD4DwB;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,uBAAA;EACA,cAAA;AC1D5B;AD8DwB;EACI,yBAAA;EACA,sBAAA;AC5D5B;AD6D4B;EACI,eAAA;AC3DhC;AD+D4B;EACI,aAAA;AC7DhC;AD+D4B;EACI,oBAAA;AC7DhC;ADgEgC;EACI,iBAAA;AC9DpC;ADoEwB;EACI,mBAAA;AClE5B;AD8EoB;EACI,0BAAA;EAAA,uBAAA;EAAA,kBAAA;AC5ExB;AD8EoB;EACI,uBAAA;EACA,kBAAA;AC5ExB;AD8EoB;EACI,SAAA;AC5ExB;AD+EwB;EACI,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;AC7E5B;AD+EwB;EACI,aAAA;AC7E5B;ADgFoB;EACI,kBAAA;AC9ExB;ADkFoB;EACI,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,SAAA;AChFxB;ADiFwB;EACI,SAAA;AC/E5B;ADiFwB;EACI,aAAA;EACA,gCAAA;EACA,mBAAA;AC/E5B;ADiFwB;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;AC/E5B;ADiFwB;EACI,UAAA;EACA,YAAA;AC/E5B;ADgF4B;EACI,mBAAA;AC9EhC;ADiFwB;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AC/E5B;ADgF4B;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AC9EhC;;AArfA;EACI,8CAAA;AAwfJ;;AArfA;EACI,SAAA;AAwfJ;AAvfI;EACI,6CAAA;AAyfR;;AAtfA;EACI,kBAAA;EACA,UAAA;EACA,eAAA;EACA,sCAAA;EAEA,kBAAA;EACA,yBAAA;EACA,qHAAA;AAwfJ;;AAtfA;EACI,gBAAA;AAyfJ;;AAvfA;EACI,gBAAA;AA0fJ;;AAxfA;EACI,wBAAA;EACA,2BAAA;EACA,eAAA;AA2fJ;AA1fI;EACI,gBAAA;EACA,iBAAA;AA4fR","sourcesContent":["@use \"sass:map\";\n@import './common.scss';\n\n@mixin MasterPage($theme){\n    * {\n        font-family: Roboto, Helvetica, Arial, sans-serif;\n    }\n    .page-container{ \n        background-color: map.get($theme,\"body-background-color\");\n        color: map.get($theme,\"text-color\");\n        position: relative;\n        .disabled {\n            pointer-events: none;\n        }\n        .rignt {\n            flex-grow: 1 !important;\n        }\n        a {\n            text-decoration: none;\n            color: inherit;\n        }\n\n        .btn {\n            background-color: map.get($theme,\"btn-bg-color\");\n            color: #fff;\n        }\n\n        button:disabled {\n            opacity: 0.7;\n        }\n\n        .card {\n            background-color: rgb(255, 255, 255);\n            background-clip: border-box;\n            color: map.get($theme,\"text-color\");\n            border: 0px solid rgba(0, 0, 0, 0.125);\n            border-radius: 0.75rem;\n            box-shadow: rgba(0, 0, 0, 0.1) 0rem 0.25rem 0.375rem -0.0625rem, rgba(0, 0, 0, 0.06) 0rem 0.125rem 0.25rem -0.0625rem;        \n        }\n\n        .strong {\n            font-weight: 500;\n        }\n          \n        @keyframes spin {\n            0%{\n               transform: rotate(0deg);\n              }\n           100%{\n               transform: rotate(360deg);\n              }\n           }\n          \n\n        .actions {\n            justify-content: center;\n            & > * {\n                margin-right: 2rem;\n            }\n        }\n\n        td {\n            position: relative;\n        }\n\n        .error {\n            color: red;\n            position: absolute;\n            font-size: small;\n            left: 18px;\n            bottom: -10px;\n            &.select {\n                bottom: -22px;\n                left: 7px\n            }\n        }\n\n        .user-form-error {\n            position: absolute;\n            left: 0;\n            bottom: -20px;\n            color: red;\n        }\n\n        .user-form-row {\n            position: relative;\n        }\n\n        .wrap-text {\n            word-wrap: break-word;\n            text-wrap: wrap;\n        }\n\n        .pagination-drop-down {\n            font-size: 12px !important;\n            font-weight: 400 !important;\n            color: rgba(0, 0, 0, 0.6) !important;\n        }\n\n        .recipe-room-link-form,.recipe-edit{\n            .error {\n                bottom: -15px;\n            }\n        }\n        .user-edit {\n            .error {\n                bottom: -4px;\n            }\n            .error.select {\n                bottom: -18px;\n            }\n        }\n\n\n\n        .edit-icon:not(.disabled),.copy-icon:not(.disabled),.hash-for-push-icon:not(.disabled) {\n            cursor: pointer;\n            &:hover {\n                color: map.get($theme,\"btn-bg-color\");\n            }\n        }\n        .hash-for-push-icon:not(.disabled) {\n            cursor: pointer;\n            &:hover {\n                color: rgb(57, 194, 57);\n            }\n        }\n        .delete-icon:not(.disabled) {\n            cursor: pointer;\n            &:hover {\n                color: #ff0000cc;\n            }\n        }\n\n        .edit-icon,.delete-icon,.copy-icon {\n            cursor: pointer;\n        }\n\n        .data-table {\n            .pagination {\n                padding: 0.5rem;\n                // .select {\n                //     width: 5rem;\n                //     height: 2rem;\n                // }\n                .right-btn,.left-btn {\n                    border: 1px solid rgba(0, 0, 0, 0.125);\n                    border-radius: 50%;\n                    padding: 0.3rem;\n                    color: rgb(73, 80, 87);\n                    height: 20px;\n                    width: 20px;\n                    &:hover {\n                        background-color: rgba(0, 0, 0, 0.05);\n                        cursor: pointer;\n                    }\n                }\n                input {\n                    padding: 0;\n                }\n                input[type='number'],.select {\n                    height: 1.5rem;\n                    width: 4.5rem;\n                }\n                input[type='number'] {\n                    border: none;\n                    padding: 0 0 0 14px;\n                    width: calc(4.5rem - 14px);\n                    color: rgba(0, 0, 0, 0.87);\n                    font-size: 0.875rem;\n                    font-weight: 400;\n                    border-radius: 0.375rem;\n                    border: 1.5px solid #d3d3d3;\n                    &:focus {\n                        border-color: #1976d2 ;\n                        border-width: 2px;\n                        outline: none;\n                    }\n                }\n            }\n            thead {\n                th:first-child {\n                    border-radius: 0.75rem 0 0 0;\n                }\n                th:last-child {\n                    border-radius: 0 0.75rem 0 0;\n                }\n            }\n            tr {\n                th,td {\n                    padding: 12px 16px;\n                }\n                th {\n                    background-color: map.get($theme,\"side-bar-background-color\");\n                    color: #fff;\n                }\n                td {\n                    background-color: rgb(255, 255, 255);\n                    color: rgb(123, 128, 154);\n                    &.hover:hover {\n                        cursor: pointer;\n                    }\n                }\n                &:nth-of-type(odd) td {\n                    background-color: rgba(0, 0, 0, 0.05);\n                }\n            }\n        }\n\n        .horizontal-divider {\n            flex-shrink: 0;\n            border-top: 0px solid rgba(0, 0, 0, 0.08);\n            border-right: 0px solid rgba(0, 0, 0, 0.08);\n            border-left: 0px solid rgba(0, 0, 0, 0.08);\n            height: 0.0625rem;\n            margin: 1rem 0px;\n            border-bottom: none;\n            opacity: 0.35;\n            background-color: transparent;\n            background-image: linear-gradient(to right, rgba(255, 255, 255, 0), rgb(255, 255, 255), rgba(255, 255, 255, 0)) !important;\n        }\n        .side-bar {\n            background-color: map.get($theme,\"side-bar-background-color\");\n            color: #fff;\n            position: sticky;\n            top: 1rem;\n            .menu-icon {\n                color: #fff;\n            }\n            .logo-icon {\n                width: 10rem;\n            }\n\n            height: calc(97vh - 2rem);\n            margin: 1rem;\n            padding: 0px;\n            border-radius: 0.75rem 0 0 0.75rem;\n\n            .menu-item {\n                padding: 0.5rem 1rem;\n                margin: 0.09375rem 1rem;\n                border-radius: 0.375rem;\n                user-select: none;\n                white-space: nowrap;\n                cursor: pointer;\n                height: 3rem;\n                &:hover {\n                    background-color: rgba(255, 255, 255, 0.2)\n                }\n            }\n            .active .menu-item {\n                background-color: map.get($theme,\"side-bar-active-menu-background-color\");\n            }\n\n            @media only screen and (max-width: 900px) {\n                .side-bar-list {\n                    width: 68px;\n                    overflow: hidden;\n                    &:hover {\n                        width: auto;\n                    }\n                }\n            }\n        }\n\n        \n        .heading {\n            color: map.get($theme,\"text-color\");\n            font-weight: 700;\n            margin: 0;\n            text-transform: capitalize;\n        }\n\n        .top_container {\n            padding: 1rem;\n            margin: 1rem;\n            outline: 1rem solid map.get($theme,\"body-background-color\");\n            margin-left: 0;\n            position: sticky;\n            border-radius: 0.75rem;\n            z-index: 1000;\n            top: 1rem;\n            background-color: white;\n            color: rgb(123, 128, 154);\n            .search-field {\n                width: 20rem;\n            }\n            .breadcrumb {\n                color: rgb(123, 128, 154);\n                .home-icon {\n                    position: relative;\n                    top: 2px;\n                }\n                & li:last-child {\n                    color: map.get($theme,\"text-color\");\n                }\n            }\n            .menu-icon {\n                user-select: none;\n                display: inline-block;\n                color: rgb(123, 128, 154);\n            }\n            .search-icon:hover,.person-wrapper,.badge-wrapper {\n                cursor: pointer;\n            }\n            .person-wrapper{\n                width: fit-content;\n            }\n            .badge-wrapper {\n                width: fit-content;\n            }\n        }\n\n        .master-page-container {\n            display: grid;\n            grid-template-columns: auto 1fr;\n            .right {\n                display: grid;\n                grid-template-rows: auto 1fr;\n            }\n            .main-content-wrapper {\n                position: relative;\n                box-sizing: border-box;\n                padding-right: 1rem;\n                .dash-board {\n                    position: relative;\n                    margin: 10px 0px;\n                    overflow: scroll;\n                    .left {\n                        flex: 0 0 auto;\n                    }\n                    .right {\n                        flex: 1;\n                    }\n                    .info-left {\n                        font-weight: 500;\n                    }\n                    .actions-dashboard {\n                        .zoom-icon,.refresh-icon {\n                            color: map.get($theme,\"btn-bg-color\");\n                        }\n                        .refresh-icon:hover {\n                            animation: spin 0.5s linear;\n                        }\n                        position: fixed;\n                        right: 3rem;\n                        top: 8.3rem;\n                        z-index: 1001;\n                        &:hover {\n                            cursor: pointer;\n                        }\n                    }\n                    &.full {\n                        background-color: map.get($theme,\"body-background-color\");\n                        box-sizing: border-box;\n                        position: fixed;\n                        top: 0;\n                        left: 0;\n                        bottom: 0;\n                        right: 0;\n                        z-index: 1000;\n                        margin: 1.5rem;\n                        overflow: scroll;\n                        .actions-dashboard {\n                            top: 3rem;\n                            right: 3rem;\n                        }\n                    }\n                    .btn {\n                        color: white\n                    }\n\n                    .title {\n                        color: map.get($theme,\"text-color\");\n                        font-weight: 700;\n                        margin: 0;\n                        text-transform: capitalize;\n                    }\n                    \n                    .chart-title,.info-title {\n                        text-align: center;\n                        color: map.get($theme,\"side-bar-active-menu-background-color\");\n                        width: fit-content;\n                        border: 1px solid map.get($theme,\"side-bar-active-menu-background-color\");\n                        text-align: center;\n                        font-size: medium;\n                        padding: 0.2rem;\n                        border-radius: 0.2rem;\n                    }\n                    .full-page-chart {\n                        padding: 1rem;\n                    }\n                    .card {\n                        position: relative;\n                        table {\n                            border-collapse: collapse;\n                            width: 100%;\n                        }\n                \n                        th, td {\n                            padding: 1rem; /* Adjust the padding for cells */\n                            text-align: left;\n                            width: 50%;\n                        }\n                        .info {\n                            td {\n                                width: auto;\n                                padding: 0.5rem;\n                            }\n                        }\n                        .chart {\n                            &.zoom-out:hover {\n                                transform: scale(1.02);\n                                cursor: pointer;\n                                background-color: rgb(0 0 0 / 6%);\n                            }\n                        }\n                    }\n                }\n                .users-page,.rooms-page,.recipes-page,.roles-page,.dash-board,.activity-page {\n                    & > * {\n                        margin-bottom: 1rem;\n                    }\n                }\n                .users-page {\n                    .user,.user-edit {\n                        // max-width: 500px;\n                        width: fit-content;\n                        min-width: 450px;\n                        td {\n                            border: 0;\n                            padding: 13px;\n                        }\n                        .check-box>td {\n                            padding: 0 13px;\n                        }\n                    }\n                }\n                .rooms-page {\n                    .room-edit,.room {\n                        width: fit-content;\n                        min-width: 450px;\n                        // max-width: 500px;\n                        // padding: 16px;\n                        table{\n                            width: 100%;\n                            border-collapse: separate;\n                            border-spacing:0 25px;\n                            td{\n                                padding: 0 10px;\n                            }\n                        }\n                        .error {\n                            bottom: -17px;\n                        }\n                    }\n                }\n                \n                .room-content,.role-content,.user-content {\n                    min-width: 350px;\n                    width: fit-content;\n                    max-width: 79vw;\n                    * {\n                        text-wrap: wrap;\n                        word-break: break-all;\n                    }\n                    > div:not(.btns) {\n                        div:first-child {\n                            font-weight: 500;\n                        }\n                        display: grid;\n                        grid-template-columns: 110px 2rem 1fr;\n                        padding: 0.6rem;\n                    }\n                    .btns {\n                        display: flex;\n                        justify-content: center;\n                        margin-top: 1rem;\n                    }\n                }\n                .recipes-page {\n                    .recipe-constraints {\n                        position: relative;\n                        width: fit-content;\n                        overflow: unset;\n                        margin-top: 10px;\n                        .title {\n                            position: absolute;\n                            margin: 0;\n                            top: -10px;\n                            left: 10px;\n                            background-color: white;\n                            padding: 0 5px;\n                        }\n                    }\n                    .recipe-edit {\n                        table:not(.data-table){\n                            border-collapse: separate;\n                            border-spacing:0 25px;\n                            td{\n                                padding: 0 10px;\n                            }\n                        }\n                        .recipe-edit-table {\n                            th {\n                                padding: 10px;\n                            }\n                            td {\n                                padding-bottom: 10px;\n                            }\n                            tr:last-child {\n                                td{\n                                    padding-bottom: 0;\n                                }\n                            }\n                        }\n                    }\n                    .form-body {\n                        & > * {\n                            margin-bottom: 1rem;\n                        }\n                    }\n                }\n                .roles-page {\n                    // table{\n                    //     border-collapse: separate;\n                    //     border-spacing: 0 10px;\n                    //     td{\n                    //         padding: 0 10px;\n                    //     }\n                    // }\n                    .role {\n                        width: fit-content;\n                    }\n                    label {\n                        background-color: white;\n                        padding-right: 5px;\n                    }\n                    .drop-down {\n                        margin: 0;\n                    }\n                    .role-edit {\n                        table {\n                            min-width: 380px;\n                            margin-right: 1rem;\n                            border-collapse: separate;\n                            border-spacing:0 25px;\n                        }\n                        .error {\n                            bottom: -16px;\n                        }\n                    }\n                    .role-creation {\n                        position: relative;\n                    }\n                }\n                .activity-page {\n                    .filter-form {\n                        min-width: 20rem;\n                        max-width: 30rem;\n                        display: flex;\n                        flex-direction: column;\n                        padding: 2rem;\n                        gap: 1rem;\n                        .select {\n                            margin: 0;\n                        }\n                        > *:not(.btns) {\n                            display: grid;\n                            grid-template-columns: 100px 1fr;\n                            align-items: center;\n                        }\n                        .action {\n                            display: flex;\n                            flex-direction: row;\n                            justify-content: space-between;\n                            margin: 0;\n                            margin-left: -10px;\n                        }\n                        .date-range {\n                            padding: 0;\n                            height: 40px;\n                            input {\n                                padding: 8.8px 10px;\n                            }\n                        }\n                        .btns {\n                            margin-top: 1rem;\n                            display: flex;\n                            flex-direction: row;\n                            justify-content: center;\n                            div {\n                                display: flex;\n                                flex-direction: row;\n                                gap: 1rem;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}","@use \"sass:map\";\n@import './masterpage.scss';\n\n$dark-theme : (\n    \"side-bar-background-color\" : rgba(0, 0, 0, 0.74),\n    \"body-background-color\" : rgb(240, 242, 245),\n    \"side-bar-active-menu-background-color\":#4da565,\n    \"text-color\":rgb(52, 71, 103),\n    \"btn-bg-color\":rgb(26, 115, 232),\n);\n\n.theme1 {\n    @include MasterPage($dark-theme);\n    \n}\n.swal2-confirm {\n    background-color: map.get($dark-theme,\"btn-bg-color\") !important;\n    // color: red !important;\n}\n.swal2-actions {\n    gap: 1rem;\n    .delete-confirm {\n        background-color: rgb(221, 51, 51) !important;\n    }\n}\n.swal2-title {\n    position: absolute;\n    width: 88%;\n    font-size: 27px;\n    border: 0px solid rgba(0, 0, 0, 0.125);\n    // border-radius: 0.75rem;\n    padding: 15px 30px;\n    background-color: #f2f2f2;\n    box-shadow: rgba(0, 0, 0, 0.1) 0rem 0.25rem 0.375rem -0.0625rem, rgba(0, 0, 0, 0.06) 0rem 0.125rem 0.25rem -0.0625rem;        \n}\n.swal2-icon {\n    margin-top: 75px;\n}\n.swal2-popup {\n    overflow: hidden;\n}\n.swal2-html-container {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n    font-size: 20px;\n    .sub-title {\n        font-weight: 600;\n        padding: 10px 0px;\n    }\n}\n\n// .swal2-icon ,.swal2-icon-show {\n//     &::before {\n//         content: Jagadeesh;\n//     }\n// }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
